/// <amd-module name="Test/TestPlansHubRefresh/TestSuiteImportPanel/Redux/TestSuiteImportPanelReducer" />
import { default as produce } from "immer";
import { ITestSuiteImportPanelState } from "./TestSuiteImportPanelContracts";
import { TestSuiteImportPanelActions, TestSuiteImportPanelActionsTypes } from "./TestSuiteImportPanelActions";

/**
 * TestSuiteImportPanelReducer: Reducer for test plan clone panel.
 */
export function TestSuiteImportPanelReducer(state: ITestSuiteImportPanelState, action: TestSuiteImportPanelActions): ITestSuiteImportPanelState {
    state = state || ({} as ITestSuiteImportPanelState);

    return produce(state, (draftState: ITestSuiteImportPanelState) => {
        switch (action.type) {
            case TestSuiteImportPanelActionsTypes.copyTestSuiteInProgress:
                draftState.cloneInProgress = true;
                break;
            case TestSuiteImportPanelActionsTypes.copyTestSuiteCompleted:
                draftState.opId = action.payload.opId;
                draftState.cloneInProgress = false;
                break;
            case TestSuiteImportPanelActionsTypes.mandatoryFieldUpdated:
                draftState.mandatoryFieldUpdated = action.payload;
                break;
            case TestSuiteImportPanelActionsTypes.projectsFetchSucceeded:
                draftState.projectList = action.payload;
                break;
            case TestSuiteImportPanelActionsTypes.testPlansFetchSucceeded:
                draftState.testPlanList = action.payload.planList;
                draftState.testPlanListProject = action.payload.project;
                break;
            case TestSuiteImportPanelActionsTypes.getTestSuitesForPlanSucceeded:
                draftState.suiteList = action.payload;
                break;
            case TestSuiteImportPanelActionsTypes.testSuiteImportPanelError:
                draftState.testPlanSelectionErrorMessage = action.payload.testPlanSelectionErrorMessage;
                break;
            case TestSuiteImportPanelActionsTypes.testSuiteImportPanelSuiteSelectionError:
                draftState.testSuiteSelectionErrorMessage = action.payload.testSuiteSelectionErrorMessage;
                break;
            case TestSuiteImportPanelActionsTypes.disableTestSuiteEditableDropdownSelection:
                draftState.disableTestSuiteDropdown = action.payload;
            default:
                break;
        }
    });
}